// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"ebab042f","184":"834bc1c2","355":"feb792e8","432":"1e1b10cd","488":"9561f9b8","524":"4ecf340f","568":"539f637c","640":"8490b728","689":"b090afdb","942":"82cfecd4","946":"7e08aa00"}[chunkId] + ".chunk.js";
};